import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Signup from "./pages/Admin/signup";
import Login from "./pages/Admin/login";
import Album from "./pages/Album";
import GlobalStyle from "./style/GlobalStyle";
import { useEffect } from "react";
import { useAlbum } from "./hooks/useAlbum";

export default function App() {
  const { currentDocs, getCurrentDocs } = useAlbum();
  useEffect(() => {
    if (!currentDocs) {
      getCurrentDocs();
    }
  }, []);

  return (
    <>
      <GlobalStyle />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/signup" element={<Signup />} />

          <Route path="/album" element={<Album />} />
          <Route path="/album/:id" element={<Album />} />

          <Route path="*" element={<div />}></Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}
